import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get
import * as transformUser from '../transformers/user';
var User = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, args, context, info) {
    var userId, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          userId = args.userId;
          url = "".concat(context.url.stargateRoot, "/users/").concat(userId, "/manage/profile");
          return _context.abrupt("return", context.fetch(url).then(function (data) {
            return data.json();
          }).then(function (res) {
            return transformUser.fromManageAPIResponse(res);
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function User(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export default User;